export default __webpack_public_path__ + "static/media/LogoNavbar.573a5873.svg";